/**
 * The top bar's icon-button treatment.
 *
 * Outlined rather than bare, and that is a deliberate usability call: an icon
 * with no visible boundary reads as decoration until the pointer happens to
 * cross it. The hamburger and the profile control are the two controls every
 * user needs within their first few seconds in the product, so both carry a
 * border and a surface — the affordance is visible before the hover.
 *
 * They are exported as one constant rather than two because the pair must stay
 * identical. Two hand-written strings is how a top bar ends up with a button
 * that is one pixel taller than its neighbour.
 */
export const topBarIconButtonClasses =
  'flex h-8 w-8 shrink-0 items-center justify-center rounded-control border border-border bg-surface-raised text-content-muted transition-colors hover:border-border-strong hover:bg-surface-sunken hover:text-content';

export const topBarIconClasses = 'h-4 w-4 shrink-0';

/** The cluster that holds the identity name and role beside the profile button. */
export const topBarIdentityClasses = 'hidden min-w-0 flex-col items-end leading-tight sm:flex';

export const topBarIdentityNameClasses = 'max-w-[10rem] truncate text-xs font-semibold text-content';

export const topBarIdentityRoleClasses = 'max-w-[10rem] truncate text-2xs text-content-muted';

export const topBarClasses =
  'sticky top-0 z-30 flex h-14 items-center justify-between gap-3 border-b border-border/80 bg-surface/85 px-4 sm:px-6 backdrop-blur-md transition-colors';

export const topBarBreadcrumbsClasses = 'min-w-0 flex-1 truncate text-xs text-content-muted';

export const topBarSlotClasses = 'flex items-center gap-2.5';
